<div class='container' *ngIf='loadingState === loadingStates.LOADED; else loadingComponent'>
    <div class='mb-3 pt-3'>
        <div class='h3'>Device Notifications ID export</div>
        <div class='lead'>
            In this page you can export all the devices with a present notificationsID appended to them. <br><br>
            Along with the device's information , related account information is also recorded in this section.

        </div>
    </div>

    <div class="d-flex flex-column justify-content-center align-items-center mt-lg-5">
        <h2 class="mb-4 fw-bold">Export Options</h2>

        <div class="d-flex flex-row gap-lg-5">
            <div class="text-center">
                <button class="ms-5 mt-2" mat-raised-button (click)="onExportCsvPressed()"
                        style="background-color: lightgreen; color: black;">
                    <mat-icon>insert_drive_file</mat-icon>
                    Export CSV
                </button>
            </div>
        </div>
    </div>
</div>
<ng-template #loadingComponent>
    <div class="container mt-5 d-flex flex-column align-items-center justify-content-center">
        <div>Fetching Accounts and Devices ... {{loadingStatus}}%</div>
    </div>
</ng-template>
